import { ReactNode } from 'react';

import { ColorOrCustom, dynamicStyling } from 'styles';

interface BoxProps {
  children?: ReactNode;
  className?: string;
  size?: number;
  backgroundColor?: ColorOrCustom;
  border?: 'rounded' | 'circle' | 'square';
}

export function Box({ children, className, size, backgroundColor, border }: BoxProps) {
  return (
    <div
      {...dynamicStyling({
        bg: backgroundColor,
        size,

        className: [
          {
            'rounded-full': border === 'circle',
            'rounded-lg': border === 'rounded',
          },

          'flex items-center justify-center shrink-0',

          className,
        ],
      })}
    >
      {children}
    </div>
  );
}
